<template>
  <BootstrapVueTable
    :title="title"
    :subtitle="subtitle"
    :search=false
    :items="table_data"
    :fields="table_fields" />
</template>

<script>
import axios from 'axios'
import errorRoutingMixin from '@/mixins/errorRoutingMixin'
import data_formats from '@/utils/data_formats'
import BootstrapVueTable from '@/components/BootstrapVueTable'

export default {
  name: 'MissingInitials',
  components: {BootstrapVueTable},
  mixins: [errorRoutingMixin],
  props: ['reference_entity', 'reference_year', 'reference_month'],
  data () {
    return {
      title: "Chefs de projet sans initiales",
      subtitle: "Ces chefs de projets apparaissent avec les initiales '---' dans les listes des projets. Pour corriger, ajouter les initiales dans AGP -> Paramètres -> Gestion des utilisateurs.",
      raw_data: [],
      table_data: [],
      table_fields: [],
    }
  },
  watch: {
    all_props () {
      this.load_server_data()
    }
  },
  created () {
    this.load_server_data()
  },
  computed: {
    all_props () {
      return [
        this.reference_entity,
        this.reference_year,
        this.reference_month  
      ]
    },
  },
  methods: {
    load_server_data () {
      if (! this.reference_entity) return  // If user is not yet authenticated. do nothing
      let url = 'webapi/anomaly-missing-initials?entity=' + this.reference_entity + '&year=' + this.reference_year + '&month=' + this.reference_month 
      axios.get(url, {headers: {'Authorization': 'Bearer ' + this.$cookies.get('jwt_access')}})
        .then(response => this.raw_data = response.data)
        .then(_ => this.build_table_data())
        .catch(error => {
          console.log(error)
          this.$router.push(this.routeOnError(error.response.status))
        })
    },

    build_table_data() {
      this.table_data = data_formats.col_to_row_format(this.raw_data)

      let sortable = {sortable: true}
      this.table_fields = [{key: 'COLLABORATORNAME', label: 'Nom', ...sortable},
                           {key: 'COLLABORATORFIRSTNAME', label: 'Prénom', ...sortable},
                           {key: 'PROJECTACRONYM', label: 'Project dirigé', ...sortable}]
    },
  }
}
</script>